<template>
  <div>
    <cancel-modal
      modal-id="my-subscription-cancel-modal"
      :visible="showCancelModal"
      :title="$t('subscription.cancel_confirm_title')"
      :message="$t('subscription.cancel_confirm_text')"
      :justification-label="$t('subscription.cancellation_reason')"
      :justification-placeholder="$t('subscription.cancel_reason_placeholder')"
      :ok-title="$t('action.confirm')"
      :cancel-title="$t('action.cancel')"
      @confirm="doCancel"
      @cancel="showCancelModal = false"
      @update:visible="showCancelModal = $event"/>

    <Grid
      ref="grid"
      :service="service"
      route_name="my_subscriptions"
      route_grid_path="/grid"
      order_column="id"
      :hide_edit="true"
      :hide_delete="true">
      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">{{ $t('subscription.id') }}</vs-th>
        <vs-th key="plan" sort-key="subscription_plan_id">{{ $t('subscription.plan') }}</vs-th>
        <vs-th key="status" sort-key="status">{{ $t('subscription.status') }}</vs-th>
        <vs-th key="latest_invoice">{{ $t('subscription.latest_invoice') }}</vs-th>
        <vs-th key="last_paid">{{ $t('subscription.last_paid_invoice') }}</vs-th>
        <vs-th key="started_at" sort-key="started_at">{{ $t('subscription.started_at') }}</vs-th>
        <vs-th key="ends_at" sort-key="ends_at">{{ $t('subscription.ends_at') }}</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="id">
            <div> {{ tr.id }} </div>
          </vs-td>
          <vs-td width="22%" key="plan">
            <div> {{ tr.subscription_plan ? tr.subscription_plan.name : '-' }}</div>
          </vs-td>
          <vs-td width="12%" key="status">
            <vs-chip transparent :color="getStatusColor(tr.status)" class="text-base">{{ tr.status_label }}</vs-chip>
          </vs-td>
          <vs-td width="14%" key="latest_invoice">
            <div class="text-sm">{{ tr.latest_invoice_status_label || '—' }}</div>
          </vs-td>
          <vs-td width="14%" key="last_paid">
            <div class="text-sm">{{ tr.last_paid_invoice_display || '—' }}</div>
          </vs-td>
          <vs-td width="10%" key="started_at">
            <div> {{ formatDate(tr.started_at) }} </div>
          </vs-td>
          <vs-td width="10%" key="ends_at">
            <div> {{ formatDate(tr.ends_at) }} </div>
          </vs-td>
          <vs-td width="13%">
            <div class="flex flex-row gap-2 items-center">
              <feather-icon
                v-permission="'my_subscriptions.show'"
                icon="EyeIcon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-primary cursor-pointer"
                v-tooltip.top="{
                  content: $t('action.consult'),
                  delay: { show: 100, hide: 100 }
                }"
                @click="$router.push({ name: 'my-subscription-detail', params: { id: tr.id } })"
              />
              <feather-icon
                v-if="canCancel(tr)"
                v-permission="'my_subscriptions.cancel'"
                icon="XCircleIcon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
                @click="openCancelModal(tr)"/>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>
import CancelModal from '@/components/CancelModal.vue'
import MySubscriptionService from '@/services/api/MySubscriptionService'

export default {
  components: {
    CancelModal
  },
  data: () => ({
    service: null,
    showCancelModal: false,
    subscriptionToCancel: null
  }),
  methods: {
    formatDate(val) {
      if (!val) return '-'
      const d = new Date(val)
      return d.toLocaleDateString('pt-BR')
    },
    canCancel(tr) {
      return tr.status === 'AC' || tr.status === 'PE'
    },
    getStatusColor(status) {
      const statusMap = {
        PE: 'warning',
        AC: 'success',
        CA: 'danger',
        EX: 'dark',
        SP: 'primary'
      }
      return statusMap[status] || 'default'
    },
    openCancelModal(tr) {
      this.subscriptionToCancel = tr
      this.showCancelModal = true
    },
    doCancel(data) {
      if (!this.subscriptionToCancel) return
      const id = this.subscriptionToCancel.id
      const reason = data?.justification || ''
      this.$vs.loading()
      this.service.cancel(id, reason).then(
        () => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          this.showCancelModal = false
          this.subscriptionToCancel = null
          this.$refs.grid?.fetchGridData(true)
        },
        error => this.notifyError(this.$vs, error?.message || this.$t('messages.error'))
      ).finally(() => this.$vs.loading.close())
    }
  },
  beforeMount() {
    this.service = MySubscriptionService.build(this.$vs)
  }
}
</script>
